

































import Vue from 'vue';
import GNB from '../components/common/GNB/GNB.vue';
import DatasetDescription from '../components/Description/Description.vue';
import { axiosApiInstance } from '../utils/axiosInstances';
import Information from '../components/Information.vue';
import Pagination from '@/components/Pagination.vue';
import NotificationMessage from '../components/common/NotificationMessage/NotificationMessage.vue';

export default Vue.extend({
  components: {
    GNB,
    DatasetDescription,
    Information,
    Pagination,
    NotificationMessage,
  },
  data(): {
    allErrorFileList: any[];
    errorFileList: any[];
    flag: boolean;
    showErrorFileList: boolean;
    componentFlag: boolean;
    dataset: {
      name: string;
      description: string;
    };
    pagination: {
      currentPage: number;
      maxPage: number;
      pageList: number[];
      firstPage: number;
      middlePage: number;
    };
  } {
    return {
      allErrorFileList: [],
      errorFileList: [],
      flag: false,
      showErrorFileList: false,
      componentFlag: false,
      dataset: {
        name: '',
        description: '',
      },
      pagination: {
        currentPage: 1,
        maxPage: 0,
        pageList: [],
        firstPage: 1,
        middlePage: 0,
      },
    };
  },
  async created() {
    // dataset관련 정보를 보여주기 위한 값들 초기화
    let result = await axiosApiInstance.get(
      `/api/v1/datasets/${this.$route.params.datasetId}`,
    );
    const dataset = result.data.result;
    this.dataset.name = dataset.name;
    this.dataset.description = dataset.description;

    result = await axiosApiInstance.get(
      `/api/v1/datasets/${this.$route.params.datasetId}/analysis/file`,
    );

    let fileMap = new Map();

    const errorFile = result.data.result;
    for (const badFile of errorFile.bad_file_size_list) {
      let index = fileMap.get(badFile.file);
      if (index === undefined) {
        this.errorFileList.push({ name: badFile.file, error_list: [] });
        index = this.errorFileList.length - 1;
        fileMap.set(badFile.file, index);
      }

      this.errorFileList[index].name = badFile.file;
      this.errorFileList[index].error_list.push('파일크기');
    }

    for (const corruptedFile of errorFile.corrupted_file_list) {
      let index = fileMap.get(corruptedFile.file);
      if (index === undefined) {
        this.errorFileList.push({ name: corruptedFile.file, error_list: [] });
        index = this.errorFileList.length - 1;
        fileMap.set(corruptedFile.file, index);
      }

      for (const targetLib of corruptedFile.target_lib) {
        this.errorFileList[index].name = corruptedFile.file;
        this.errorFileList[index].error_list.push(`손상:${targetLib}`);
      }
    }

    for (const badResolution of errorFile.bad_resolution_list) {
      let index = fileMap.get(badResolution.file);
      if (index === undefined) {
        this.errorFileList.push({ name: badResolution.file, error_list: [] });
        index = this.errorFileList.length - 1;
        fileMap.set(badResolution.file, index);
      }

      this.errorFileList[index].name = badResolution.file;
      this.errorFileList[index].error_list.push('해상도');
    }

    for (const badDuration of errorFile.bad_duration_list) {
      let index = fileMap.get(badDuration.file);
      if (index === undefined) {
        this.errorFileList.push({ name: badDuration.file, error_list: [] });
        index = this.errorFileList.length - 1;
        fileMap.set(badDuration.file, index);
      }

      this.errorFileList[index].name = badDuration.file;
      this.errorFileList[index].error_list.push('길이');
    }

    this.allErrorFileList = this.errorFileList;

    //pagination을 위한 값들 초기화
    this.pagination.currentPage = 1;
    this.pagination.maxPage = Math.ceil(this.allErrorFileList.length / 10);
    if (this.pagination.maxPage > 10) {
      for (let num = 1; num <= 10; num++) this.pagination.pageList.push(num);
    } else {
      for (let num = 1; num <= this.pagination.maxPage; num++)
        this.pagination.pageList.push(num);
    }
    this.pagination.middlePage =
      this.pagination.pageList[this.pagination.pageList.length / 2];

    this.changeDataList(1);
    this.componentFlag = true;
    if (this.allErrorFileList.length !== 0) this.showErrorFileList = true;
  },
  methods: {
    changeDataList(page: number) {
      this.errorFileList = this.allErrorFileList.slice(
        (page - 1) * 10,
        page * 10,
      );
      this.pagination.currentPage = page;
    },
  },
});
